import FieldInput from '../TicketRow/Field/FieldInput'
import FieldSelect from '../TicketRow/Field/FieldSelect'

import styles from './index.module.scss'

export default function GeneralFields() {

    return (
        <div className={styles.company}>
            <h4>Your company details</h4>
            <div className={styles.fields}>
                {window.extra_acf_booking_fields.map(field => {
                    
                    switch(field.type) {
                        case 'text':
                        case 'first_name':
                        case 'last_name':
                        case 'email':
                            return <FieldInput name={field.name} field={{ label: field.label }} />
                        case 'select':
                            return <FieldSelect name={field.name} field={{ label: field.label, options: Object.keys(field.choices) }} />
                    }

                })}
                {/**<FieldInput name="company_name" index={1} fieldKey={"hello"} field={{ "label": "Company Name" }} />
                <FieldSelect name="company_type" index={1} fieldKey={"hello"} field={{ "label": "Company Type", options: companyTypes }} />*/}
            </div>
        </div>
    )

}
